import { ApiService } from './ApiService';
import { IGetOneResponse } from '../util/Types/Generic';
export class VectorService extends ApiService {
  static pathName = '/vector';

  static addFile = (
    query: {
      nameSpace: string;
      url?: string;
      spaceId?: string;
    },
    body?: FormData,
  ): Promise<IGetOneResponse<any>> => {
    return ApiService.post(`${this.pathName}/add`, body, {
      nameSpace: query.nameSpace,
      ...(query.url ? { url: [query.url] } : {}),
      ...(query.spaceId ? { spaceId: query.spaceId } : {}),
    });
  };

  static deleteFile = (query: {
    nameSpace: string;
    id: string;
    fileName?: string;
    spaceId?: string;
  }) => {
    return ApiService.delete(
      `${this.pathName}/document/${query.fileName}?${
        query.id ? `id=${query.id}` : ''
      }&nameSpace=${query.nameSpace}${
        query.spaceId ? `&spaceId=${query.spaceId}` : ''
      }`,
    );
  };

  static deleteNameSpace = (query: {
    nameSpace: string;
    id: string;
    spaceId?: string;
  }) => {
    return ApiService.delete(
      `${this.pathName}/delete-nameSpace?${
        query.id ? `id=${query.id}` : ''
      }&name=${query.nameSpace}${
        query.spaceId ? `&spaceId=${query.spaceId}` : ''
      }`,
    );
  };

  static searchFile = (
    body: {
      prompt: string;
      model: string;
      topK: number;
      maxTokenModel: number;
      isNERSearch: boolean;
    },
    query: {
      nameSpace: string;
      id: string;
    },
  ): Promise<IGetOneResponse<any>> => {
    return ApiService.post(
      `${this.pathName}/search-queue?${
        query.id ? `id=${query.id}` : ''
      }&nameSpace=${query.nameSpace}`,
      body,
    );
  };

  static search = (
    body: {
      prompt: string;
      model: string;
      topK: number;
      maxTokenModel: number;
      isNERSearch: boolean;
      embeddingModelName: string;
      returnRaw: boolean;
    },
    query: {
      nameSpace: string;
      id: string;
    },
  ): Promise<IGetOneResponse<any>> => {
    return ApiService.post(
      `${this.pathName}/search?${query.id ? `id=${query.id}` : ''}&nameSpace=${
        query.nameSpace
      }`,
      body,
    );
  };

  static similaritySearch = (query: {
    nameSpace: string;
    query: string;
    size?: number;
  }): Promise<IGetOneResponse<any>> => {
    return ApiService.get(
      `${this.pathName}/similarity-search?nameSpace=${query.nameSpace}&query=${
        query.query
      }${query.size ? `&size=${query.size}` : ''}`,
    );
  };
}
